import TopBar from '../components/TopBar';
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import BigLogo from '../img/piska_center.png'

import SiteLinks from "../components/SiteLinks";
import { useAuth } from "../components/AuthProvider";

function Home() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const { user } = useAuth();
    
    return (
      <Box id="main" flexDirection="column" justifyContent="flex-start">
        <TopBar/>
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ m : "60px 0 0 0"}}>
          <img src={BigLogo} style={{width: '300px'}} alt="Piska"/>
          <Typography
            variant="h6"
            color={colors.ceriseAccent[900]}
            fontWeight="medium" 
            sx={{m : "0 0 0 0" }}
            >
            Brutalt välkommen till
          </Typography>
          <Typography
            variant="h3"
            color={colors.ceriseAccent[900]}
            fontWeight="regular" 
            sx={{m : "0 0 0 0" }}
            >
            Baxappen
          </Typography>
          <Typography
            variant="h6"
            color={colors.ceriseAccent[900]}
            fontWeight="regular" 
            sx={{m : "5px 0 0 0" }}
            >
            {
              user !== null ? user.name : ""
            }
          </Typography>
          <SiteLinks admin/>
        </Box>
      </Box>
    )
}

export default Home;